import React from 'react';
import ChildComponent from './ChildComponent';

const ParentComponent = ({ title }) => {
  return (
    <div>
      <h1>I am the Parent</h1>
      <h2>{title}</h2> 
      <ChildComponent message="Hello from parent!" />
    </div>
  );
};

export default ParentComponent;
